function safeHttpUrl(value) {
  if (!value) return undefined;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : undefined;
  } catch (error) {
    return undefined;
  }
}

function domainFromUrl(value) {
  const url = safeHttpUrl(value);
  if (!url) return '';
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch (error) {
    return '';
  }
}

function normalizeSource(item, kind, requireImage = false) {
  const previewUrl = safeHttpUrl(
    item?.previewUrl
      || item?.imageUrl
      || item?.mediaUrl
      || item?.image_url
      || item?.attribution_url
      || item?.attributionUrl,
  );
  const sourceUrl = safeHttpUrl(
    item?.sourceUrl
      || item?.pageUrl
      || item?.source_url
      || item?.url,
  );
  if ((requireImage && !previewUrl) || (!previewUrl && !sourceUrl)) return null;
  return {
    kind,
    url: previewUrl,
    previewUrl,
    sourceUrl,
    title: item?.title || item?.caption || item?.sourceName || 'Grounding source',
    snippet: item?.snippet || item?.text || '',
    domain: item?.domain
      || item?.sourceDomain
      || item?.sourceName
      || domainFromUrl(sourceUrl),
    publishDate: item?.publishDate || item?.date,
  };
}

function normalizeSources(items, kind, requireImage = false) {
  const seen = new Set();
  return (Array.isArray(items) ? items : [])
    .map((item) => normalizeSource(item, kind, requireImage))
    .filter((item) => {
      const key = item?.sourceUrl || item?.previewUrl;
      if (!item || !key || seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .slice(0, 12);
}

export function groundingImages(response) {
  const agentImages = response?.debug?.vtag?.groundingImages
    || (Array.isArray(response?.grounding) ? response.grounding : null);
  if (Array.isArray(agentImages) && agentImages.length > 0) {
    return agentImages
      .map((item) => {
        const url = safeHttpUrl(
          item?.imageUrl || item?.mediaUrl || item?.attribution_url || item?.attributionUrl,
        );
        const pageUrl = safeHttpUrl(
          item?.pageUrl || item?.source_url || item?.sourceUrl,
        );
        return {
          url,
          previewUrl: url,
          title: item?.caption || item?.title || item?.sourceName || 'Grounding image',
          sourceUrl: pageUrl,
          domain: item?.sourceDomain || item?.domain || item?.sourceName || '',
        };
      })
      .filter((item) => item.url)
      .slice(0, 8);
  }

  const images = response?.mmir_images_grounding
    || response?.mmir_images_aug
    || response?.icg_images
    || [];
  return images
    .map((item) => {
      const url = safeHttpUrl(item?.url || item?.image_url || item?.imageUrl);
      return {
        url,
        previewUrl: url,
        title: item?.source_metadata?.title
          || item?.ims_source_title
          || item?.caption
          || item?.title
          || 'Grounding image',
        sourceUrl: safeHttpUrl(item?.source_url || item?.attribution_url || item?.pageUrl),
        domain: item?.source_metadata?.domain || item?.sourceDomain || item?.sourceName || '',
      };
    })
    .filter((item) => item.url)
    .slice(0, 8);
}

export function groundingSources(response) {
  const structured = response?.grounding && !Array.isArray(response.grounding)
    ? response.grounding
    : {};
  const webSearch = normalizeSources(
    structured?.webSearch?.sources || response?.debug?.webSearch?.sources,
    'web_search',
  );
  let reverseImageSearch = normalizeSources(
    structured?.vtag?.reverseImageSearch,
    'reverse_image_search',
    true,
  );
  if (reverseImageSearch.length === 0) {
    const legacyVisualImages = response?.debug?.vtag?.groundingImages
      || (Array.isArray(response?.grounding) ? response.grounding : []);
    reverseImageSearch = normalizeSources(
      legacyVisualImages,
      'reverse_image_search',
      true,
    ).map((item) => ({
      ...item,
      snippet: '',
      publishDate: undefined,
    }));
  }
  const searches = Array.isArray(structured?.webSearch?.searches)
    ? structured.webSearch.searches.slice(0, 8)
    : [];
  return {
    webSearch,
    searches,
    vtagWeb: [],
    reverseImageSearch,
    traceId: structured?.vtag?.traceId || response?.debug?.vtag?.traceId || null,
    total: webSearch.length + reverseImageSearch.length,
  };
}
